import request from 'ynf-core-engine/request';

export default class APIS {
  props: any;
  domainKey: string;
  serviceCode: string;
  billNo: string;
  tplId: string;
  baseUrl: string;
  msgUtil: any;
  constructor (props: any) {
    this.props = props;
    this.domainKey = '';
    this.serviceCode = '';
    this.billNo = '';
    this.tplId = '';
    this.baseUrl = '/mdf-node/qtmProxy'
  }

  getParams = (params: any) => {
    this.billNo = params.billNo;
    this.tplId = params.tplId;
    this.domainKey = params.domainKey;
    this.serviceCode = params.serviceCode;
    this.msgUtil = params.utils;
  }

  // 删除方案
  async delSolution (solutionId: string | number) {
    try {
      const res = await request({
        url: `${this.baseUrl}/ypd/bill/filter/deleteQuerySchema?domainKey=${this.domainKey}&serviceCode=${this.serviceCode}`,
        method: 'post',
        data: {
          billNo: this.billNo,
          tplId: this.tplId,
          solutionId
        }
      });
      const { code, message } = res;
      if (code === 200) {
        this.msgUtil.message.success(message);
      } else {
        this.msgUtil.message.danger(message);
      }
      return res;
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8012E', '删除方案失败'));
    }
  }

  // 获取查询方案列表数据
  async getSolutionList () {
    try {
      const res = await request({
        url: `${this.baseUrl}/ypd/bill/filter/getAllQuerySchema?domainKey=${this.domainKey}&serviceCode=${this.serviceCode}`,
        method: 'post',
        data: {
          billNo: this.billNo,
          tplId: this.tplId
        }
      });
      const { code, data, message } = res;
      if (code === 200) {
        return data;
      } else {
        this.msgUtil.message.danger(message);
        console.error('获取查询方案列表数据失败', message);
        return [];
      }
    } catch {
      this.msgUtil.message.danger(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8012D', '获取查询方案列表数据失败'));
    }
  }

  // 设为默认
  async setDefaultFilter (solutionId) {
    try {
      const res = await request({
        url: `${this.baseUrl}/ypd/bill/filter/setDefaultQuerySchema?domainKey=${this.domainKey}&serviceCode=${this.serviceCode}`,
        method: 'post',
        data: {
          billNo: this.billNo,
          tplId: this.tplId,
          solutionId
        }
      });
      const { code, message } = res;
      if (code === 200) {
        this.msgUtil.message.success(message);
      } else {
        this.msgUtil.message.danger(message);
      }
      return res
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80136', '设为默认失败'));
    }
  }
}
